import { UserRoles } from "@/sx-layout/components/plotmap/models";

export interface LayoutMasters {
  construction_id: number;
  user_role: UserRoles;
  plot_plans: PlotPlan[];
  machine_types: MachineType[];
  companies_machine_types: CompaniesMachineType[];
  companies: Company[];
  users: User[];
  machine_icons: MachineIconSetting[];
}

export interface User {
  user_id: number;
  company_id: number;
  user_name: string;
  phone_number: string;
  role: number;
  timestamp: Timestamp;
}

export interface Company {
  company_id: number;
  company_name: string;
  icon_color: string;
  timestamp: Timestamp;
}

export interface CompaniesMachineType {
  company_machine_type_id: number;
  company_id: number;
  machine_type_id: number;
  timestamp: Timestamp;
}

export interface MachineType {
  machine_type_id: number;
  machine_icon_id: number;
  machine_type_name: string;
  timestamp: Timestamp;
}

export interface PlotPlan {
  plot_plan_id: number;
  plot_plan_name: string;
  quality: number;
  map_image_id: number;
  timestamp: Timestamp;
}

export interface Timestamp {
  insert_date: string;
  insert_user_id: number;
  insert_user_name: string;
  update_date: string;
  update_user_id: number;
  update_user_name: string;
}

export interface MachineIconSetting {
  machine_icon_id: number;
  icon_color: string;
  timestamp: Timestamp;
}
